import React from "react";
import RenderFields from "../ui/RenderFields";
import PopupPreview from "../PopupPreview";

const PopupConfigCard = ({
  project,
  folders,
  selectedFolder,
  setSelectedFolder,
  sanitizeDomain,
  form,
  setForm,
  payloadDefault,
  submitForm,
  newEmail,
  setNewEmail,
  addSubProjectNotificationEmail,
  removeSubProjectNotificationEmail,
  loading
}) => {
  return (
    <div className="details-card">
      <div className="details-card-header">
        <span>
          <i className="bi bi-window me-2"></i> Popup Configuration
        </span>
        <div className="d-flex align-items-center gap-3">
          <span className="fs-7 text-muted fw-normal">Target:</span>
          <select
            className="form-select form-select-sm target-dropdown"
            style={{ minWidth: "250px" }}
            value={selectedFolder || ""}
            onChange={(e) => setSelectedFolder(e.target.value)}
          >
            {folders.includes(sanitizeDomain(project.domain)) && (
              <option value={sanitizeDomain(project.domain)}>
                {project.domain} (Main Project)
              </option>
            )}
            {folders
              .filter((f) => f !== sanitizeDomain(project.domain))
              .map((f) => (
                <option key={f} value={f}>
                  └─ {f}
                </option>
              ))}
          </select>
        </div>
      </div>
      <div className="details-card-body">
        {/* Target Information */}
        <div className="alert alert-light border mb-4">
          <div className="d-flex align-items-start gap-2">
            <i className="bi bi-info-circle text-primary mt-1"></i>
            <div>
              <strong>Current Target:</strong>{" "}
              {selectedFolder === sanitizeDomain(project.domain) ? (
                <>
                  <span className="text-success">Main Project</span>
                  <div className="fs-7 text-muted mt-1">
                    Configuration applies to:{" "}
                    <code className="bg-light px-2 py-1 rounded">
                      {project?.domain}
                    </code>
                  </div>
                </>
              ) : (
                <>
                  <span className="text-primary">
                    Sub-Project "{selectedFolder}"
                  </span>
                  <div className="fs-7 text-muted mt-1">
                    Configuration applies to:{" "}
                    <code className="">
                      {project?.domain}/{selectedFolder}
                    </code>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {form && (
          <RenderFields
            data={payloadDefault}
            form={form}
            onChange={setForm}
          />
        )}

        {/* Live Popup Preview */}
        <div className="mt-4 pt-4 border-top">
          <h6 className="mb-3 text-muted fw-semibold">Live Preview</h6>
          <PopupPreview
            formData={form}
            domain={project?.domain}
            selectedFolder={selectedFolder}
          />
        </div>

        <div className="mt-4 pt-3 border-top">
          <button onClick={submitForm} className="btn btn-primary px-4">
            Apply Changes
          </button>
        </div>

        {/* Sub-Project Email Notification Section */}
        <div className="mt-4 pt-3 border-top">
          <h6 className="mb-3 text-muted fw-semibold">
            Notification Emails
          </h6>
          <p className="text-muted fs-9">
            Emails will be set for only{" "}
            {selectedFolder === sanitizeDomain(project.domain)
              ? project.domain
              : project.domain + "/" + selectedFolder}{" "}
          </p>
          <div className="py-3">
            <div className="input-group mb-4" style={{ maxWidth: "500px" }}>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email address"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                onKeyPress={(e) =>
                  e.key === "Enter" && addSubProjectNotificationEmail()
                }
                disabled={loading}
              />
              <button
                className="btn btn-primary"
                onClick={addSubProjectNotificationEmail}
                disabled={loading || !newEmail}
              >
                {loading ? "Adding..." : "Add Email"}
              </button>
            </div>

            {form?.notificationEmails?.length > 0 ? (
              <div className="d-flex flex-column gap-2">
                {form?.notificationEmails?.map((email, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center bg-light p-3 rounded border"
                  >
                    <span className="fw-medium">{email}</span>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() =>
                        removeSubProjectNotificationEmail(email)
                      }
                      disabled={loading}
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-muted fst-italic">
                No additional notification emails configured.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupConfigCard;
